import { render, staticRenderFns } from "./pToast.vue?vue&type=template&id=98e47482&scoped=true&"
import script from "./pToast.vue?vue&type=script&lang=js&"
export * from "./pToast.vue?vue&type=script&lang=js&"
import style0 from "./pToast.vue?vue&type=style&index=0&id=98e47482&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e47482",
  null
  
)

export default component.exports